import {View} from "react-native";
import {styles} from "../common/styles";
import React from "react";

export const MainViewHeader = () => {
    return (
        <View style={styles.headerView}>
            <View style={{ width: 22 }} />
        </View>
    )
}
